import { gql } from "@apollo/client";

export const UPLOAD_QUESTIONS_BANK = gql`
mutation uploadQuestionBanks($cId: String!, $filename: String!, $filepath: String!, $filesize: BigInt!, $isClassroom: Boolean!, $sjId: String!) {
  uploadQuestionBanks(
    input: {filepath: $filepath, cId: $cId, filename: $filename, filesize: $filesize, isClassroom: $isClassroom, sjId: $sjId}
  )
}
`
export const GET_ALL_QUESTIONS_BANK = gql`
query getAllQuestionBanks($input: getQuestionBankInput!) {
  getAllQuestionBanks(input: $input) {
    allquestionbanks {
      fileId
      filepath
      filename
      filesize
      isclassroom
      questions
      status
      totalQuestions
      totalScore
      feedId
    }
    totalCount
  }
}
`

export const UPDATE_QUESTIONS_BANK_RESULTS = gql`
mutation updateQuestionBankResults($input: updateQuestionBankInput!) {
  updateQuestionBankResults(input: $input) {
    colorCode
    message
    totalQuestions
    totalScore
  }
}
`